module.exports = __webpack_public_path__ + "img/ICX.3481721b.svg";